export default __webpack_public_path__ + "static/media/DINPro.91ff1aa7.woff";